import { Paper, Typography } from "@material-ui/core";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import React from "react";
import { ExpandableStatisticsComponentProps } from "./ExpandableStatisticsComponentProps";
import { expandableStatisticsComponentStyles } from "./ExpandableStatisticsComponentStyles";

export default function ExpandableStatisticsComponent(
    props: ExpandableStatisticsComponentProps
) {
    const classes = expandableStatisticsComponentStyles();

    return (
        <Paper className={classes.component} elevation={0}>
            <Typography className={classes.title} variant="h4">
                {props.title}
            </Typography>
            {props.isLoading ? (
                <LoadingIndicator className={classes.loadingIndicator} />
            ) : (
                <>
                    <Typography className={classes.text} variant="h5">
                        Min: &nbsp;
                        <span className={classes.unitsFont}>{props.min}</span>
                    </Typography>
                    <Typography className={classes.text} variant="h5">
                        Max: &nbsp;
                        <span className={classes.unitsFont}> {props.max}</span>
                    </Typography>
                    <Typography className={classes.text} variant="h5">
                        Mean: &nbsp;
                        <span className={classes.unitsFont}>{props.mean}</span>
                    </Typography>
                    <Typography className={classes.text} variant="h5">
                        Standard
                        <br></br>
                        Deviation: &nbsp;
                        <span className={classes.unitsFont}>
                            {props.stdDev}
                        </span>
                    </Typography>
                </>
            )}
        </Paper>
    );
}
